/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateDocumentRequestDtoGen,
  MrfiktivDocumentRequestControllerFindAllParamsGen,
  MrfiktivDocumentRequestPopulatedViewModelGen,
  MrfiktivDocumentRequestViewModelGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateDocumentRequestDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DocumentRequest<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags document-request
   * @name DocumentRequestControllerCreate
   * @summary Create a document request
   * @request POST:/partner/{partnerId}/document-request
   * @secure
   * @response `201` `MrfiktivDocumentRequestPopulatedViewModelGen` Created document request
   */
  documentRequestControllerCreate = (
    partnerId: string,
    data: MrfiktivCreateDocumentRequestDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRequestPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/document-request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-request
   * @name DocumentRequestControllerFindAll
   * @summary Get all document requests
   * @request GET:/partner/{partnerId}/document-request
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivDocumentRequestViewModelGen)[] })`
   */
  documentRequestControllerFindAll = (
    { partnerId, ...query }: MrfiktivDocumentRequestControllerFindAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivDocumentRequestViewModelGen[] }, any>({
      path: `/partner/${partnerId}/document-request`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-request
   * @name DocumentRequestControllerGetOne
   * @summary Get a document request
   * @request GET:/partner/{partnerId}/document-request/{id}
   * @secure
   * @response `200` `MrfiktivDocumentRequestPopulatedViewModelGen` Found document request
   */
  documentRequestControllerGetOne = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDocumentRequestPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/document-request/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-request
   * @name DocumentRequestControllerUpdate
   * @summary Update a document request
   * @request PATCH:/partner/{partnerId}/document-request/{id}
   * @secure
   * @response `200` `MrfiktivDocumentRequestPopulatedViewModelGen` Updated document request
   */
  documentRequestControllerUpdate = (
    partnerId: string,
    id: string,
    data: MrfiktivUpdateDocumentRequestDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRequestPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/document-request/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-request
   * @name DocumentRequestControllerDelete
   * @summary Delete a document request
   * @request DELETE:/partner/{partnerId}/document-request/{id}
   * @secure
   * @response `200` `MrfiktivDocumentRequestPopulatedViewModelGen` Deleted document request
   */
  documentRequestControllerDelete = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDocumentRequestPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/document-request/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
}
